import img1 from "../assets/images/sliders/classic/arab_workspace.avif";
import img2 from "../assets/images/sliders/classic/international.avif"; //arab_red_ring.avif
import img3 from "../assets/images/sliders/classic/coding.avif";
import img4 from "../assets/images/sliders/classic/s-ivisita.avif";

const aboutCards = [
  {id:1, count: 20, countString: '20 Plus', title: 'Years Experience', borderPosition: 'md:border-r-4'},
  {id:2, count: 125, countString: '125 Plus', title: 'Projects', borderPosition: 'md:border-b-4'},
  {id:3, count: 68, countString: '68 Plus', title: 'Happy Clients', borderPosition: 'md:border-t-4'},
  {id:4, count: 50, countString: '10 Plus', title: 'Products', borderPosition: 'md:border-l-4'},
]

const aboutVision = [
  {id:1, title: 'Transparency', description: 'Transparency, as used in science is operating in such a way that it is easy for others to see what actions are performed.'},
  {id:2, title: 'Integrity', description: 'We act with integrity by being honest, consistent, and respectful in all our decisions and interactions.'},
  {id:3, title: 'Innovation', description: 'We continuously explore new ideas to create smarter, more efficient solutions for a better future.'},
]

const serviceData = [
  {
    id: 1,
    title: 'Mobile Applications Development',
    description: 'Complexity delivered in a simple solution — creating powerful, high performance mobile apps, built with your success in mind.',
    imgName: 'mbd.avif',
    routeLink: '/services/mobile-development/'
  },
  {
    id: 2,
    title: 'Web Application',
    description: 'Mesoft uses structured framework programming, best programming practices, coding guidelines and standards. As the technology advances ',
    imgName: 'wa.avif',
    routeLink: '/services/web-application-development/'
  },
  {
    id: 3,
    title: 'ERP Solutions',
    description: 'In today s world of globalization and price pressures, its imperative that your enterprise resource planning systems offer business...\n',
    imgName: 'erp.avif',
    routeLink: '/services/erp-solutions/'
  },
  {
    id: 4,
    title: 'Customized Windows Applications',
    description: 'More than a decade, we have been envisioning, designing and delivering products and services which assure  the best quality.',
    imgName: 'cwa.avif',
    routeLink: '/services/customized-software/'
  },
]

const portfolioData = [
  {id: 1, imgName: 'ios-ivisita-login.avif', position: 0, title: 'Visitor Management Software', description: 'iVisita is a bilingual, intuitive visitor management  solution developed by MESOFT. It simplifies front  desk operations, enhances security, and ensures a  seamless, professional experience for every visitor. Whether pre-registered or a walk-in, visitors can  check in quickly via kiosks or the app.  Hosts receive instant notifications, badges are  issued, and secure access is granted—creating a  fast, safe, and efficient entry process.'},
  {id: 2, imgName: 'ios-ivisita.avif', position: 1, title: 'Host App Dashboard',
    description: "This is the main dashboard of the iVisita Visitor Management System mobile app, developed by MESOFT in the UAE.\n" +
      "It provides a quick overview of visitor activity for a selected date range, including:\n" +
      "\n" +
      "Total pre-bookings\n" +
      "\n" +
      "Pending approvals (both pre-booked and walk-in)\n" +
      "\n" +
      "Checkout violations (visitors who didn’t check out)\n" +
      "\n" +
      "A visual chart showing the percentage of pre-booked vs walk-in visitors.\n" +
      "\n" +
      "The interface is clean and user-friendly, allowing staff to easily monitor and manage visitor flow in real-time."
  },
]

const menuDb = {
  mainMenu: [
    // { id: 1, title: 'Home', translateKey: 'home', routePath: '/' },
    { id: 1, title: 'About', translateKey: 'about', routePath: '/about' },
    { id: 2, title: 'Products', translateKey: 'products', routePath: '/products',
      menuImg: 'menu-meeting-room.avif',
      submenu: [
        { id: 21, footerShow: true, hideShow: true, title: 'Visitor Management Software', translateKey: 'visitorManagementSoftware', routePath: '/products/visitor-management-software/', menuImg: 'menu-ivisita.avif' },
        { id: 22, footerShow: true, hideShow: true, title: 'Meeting Room Management', translateKey: 'meetingRoomManagementSolutions', routePath: '/products/meeting-room-solutions/', menuImg: 'menu-meeting-room.avif' },
        { id: 23, footerShow: true, hideShow: true, title: 'Paperless Board Meeting', translateKey: 'paperlessBoardMeeting', routePath: '/products/paperless-board-meeting/', menuImg: 'menu-paperless-meeting.avif' },
        { id: 24, footerShow: false, hideShow: false, title: 'Work Flow Software', translateKey: 'workFlowSoftware', routePath: '/products/c-flow/', menuImg: 'menu-c-flow.avif' },
        { id: 25, footerShow: true, hideShow: true, title: 'Files Sharing and Collaboration', translateKey: 'fileSharingAndCollaboration', routePath: '/products/file-cloud/', menuImg: 'menu-file-cloud.avif' },
        { id: 26, footerShow: false, hideShow: false, title: 'IT Network Monitoring & Reporting Appliance', translateKey: 'itNetworkAndMonitoring', routePath: '/products/it-networking-reporting-appliance/', menuImg: 'menu-it-network-monitoring.avif' },
        { id: 27, footerShow: false, hideShow: false, title: 'Environmental Monitoring', translateKey: 'environmentalMonitoring', routePath: '/products/environment-monitoring-system/', menuImg: 'menu-environment-monitoring-system.avif' },
        { id: 28, footerShow: true, hideShow: true, title: 'WEEDS BlackBox Suite', translateKey: 'weedsBlackBox', routePath: '/products/weeds-black-box-suite/', menuImg: 'menu-weeds.avif' },
        { id: 29, footerShow: true, hideShow: false, title: 'AnyDB', translateKey: 'anyDb', routePath: '/products/anydb/', menuImg: 'menu-anydb.avif' },
      ]
    },
    {
      id: 3,
      title: 'Services',
      translateKey: 'services',
      routePath: '/services',
      submenu: [
        { id: 33, hideShow: true, title: 'Customized Software', translateKey: 'customizedSoftware', routePath: '/services/customized-software/', menuImg: 'menu-customized-software.avif' },
        { id: 31, hideShow: true, title: 'Web Application Development', translateKey: 'webApplicationDevelopment', routePath: '/services/web-application-development/', menuImg: 'menu-web-application-development.avif' },
        { id: 32, hideShow: true, title: 'Mobile Application Development', translateKey: 'mobileApplicationDevelopment', routePath: '/services/mobile-development/', menuImg: 'menu-mobile-application-development.avif' },
        { id: 34, hideShow: true, title: 'ERP Solutions', translateKey: 'erpSolutions', routePath: '/services/erp-solutions/', menuImg: 'menu-erp-solutions.avif' },
        { id: 35, hideShow: true, title: 'IT Solutions', translateKey: 'itSolutions', routePath: '/services/it-solutions', menuImg: 'menu-it-solutions.avif' },
      ]
    },
    // { id: 4, title: 'Testimonial', routePath: '/testimonial' },
    { id: 5, title: 'Careers', translateKey: 'careers', routePath: '/career' },
    { id: 6, title: 'Contact', translateKey: 'contact', routePath: '/contact' }
  ]
}

const navList = {
  products: [
    {id: 1, routePath: 'products/visitor-management-software/'},
    {id: 2, routePath: 'products/paperless-board-meeting/'},
    {id: 3, routePath: 'products/meeting-room-solutions/'},
    {id: 4, routePath: 'products/files-sharing-and-collaboration/'},
    {id: 5, routePath: 'products/work-flow-software/'},
    {id: 6, routePath: 'products/it-network-monitoring-and-reporting-appliance/'},
    {id: 7, routePath: 'products/environmental-monitoring/'}
  ],
  services: [
    {id: 1, routePath: 'services/mobile-development/'},
    {id: 2, routePath: 'services/customized-software/'},
    {id: 3, routePath: 'services/web-application-development/'},
    {id: 4, routePath: 'services/erp-solutions/'},
  ]
}

const clientSlider = {
  first: [
    {id:1, title: 'Acer', imgName: 'acer.avif'},
    {id:2, title: 'DHL', imgName: 'dhl.avif'},
    {id:3, title: 'Digital DU', imgName: 'digital-du.avif'},
    {id:4, title: 'En', imgName: 'en.avif'},
    {id:5, title: 'RTA', imgName: 'rta.avif'},
    {id:6, title: 'CMA-CMG', imgName: 'cma-cmg.avif'},
    {id:7, title: 'Cosco', imgName: 'cosco.avif'},
    {id:8, title: 'Daman 8', imgName: 'daman.avif'},
    {id:9, title: 'Nama', imgName: 'nama.avif'},
    {id:10, title: 'Nbb', imgName: 'nbb.avif'},
  ],
  second: [
    {id:1, title: 'client 1', imgName: 'uaeu.avif'},
    {id:2, title: 'client 2', imgName: 'zau.avif'},
    {id:3, title: 'client 3', imgName: 'titan.avif'},
    {id:4, title: 'client 4', imgName: 'rabdan.avif'},
    {id:5, title: 'client 5', imgName: 'masdar.avif'},
    {id:6, title: 'client 6', imgName: 'fanr.avif'},
    {id:7, title: 'client 7', imgName: 'desc.avif'},
    {id:8, title: 'client 8', imgName: 'dafz.avif'},
    {id:9, title: 'client 9', imgName: 'cudu.avif'},
    {id:10, title: 'client 10', imgName: 'asc.avif'},
  ],
  third: [
    {id:1, title: 'client 1', imgName: 'ahla.avif'},
    {id:2, title: 'client 2', imgName: 'amsraf.avif'},
    {id:3, title: 'client 3', imgName: 'anantara.avif'},
    {id:4, title: 'client 4', imgName: 'bm.avif'},
    {id:5, title: 'client 5', imgName: 'hras.avif'},
    {id:6, title: 'client 6', imgName: 'inb.avif'},
    {id:7, title: 'client 7', imgName: 'naffco.avif'},
    {id:8, title: 'client 8', imgName: 'nbq.avif'},
    {id:9, title: 'client 9', imgName: 'scp.avif'},
    {id:10, title: 'client 10', imgName: 'smbc.avif'},
  ],
}

const productSlider = [
  {id:1, name:'Visitor Management Software', imgName: 'ivisita.avif',
    link: '/products/visitor-management-software/',
    description: 'iVisita is a complete solution for paperless visitor management system and it will leave a good impression on the visitors with its fast and easy registration process.Check-in and check-out made super easy so that the visitors can spend less time at the reception.'
  },
  {id:2, name:'Meeting Room Management Solutions', imgName: 'mrm.avif',
    link: '/products/meeting-room-solutions/',
    description: 'Manager is the beautiful touch-screen solution for all your meeting rooms. Make sure they’re being used in a truly effective way. Forget about double bookings, confusion and interrupted meetings'
  },
  // {id:3, name:'Work Flow Software', imgName: 'cflow.avif',
  //   link: '/products/c-flow/',
  //   description: 'Cflow is simple to start with. Powerful when you dive deep into its vast collection of features. With this one BPM software, you can get tons of work done.'
  // },
  {id:4, name:'Paperless Board Meetings', imgName: 'bm.avif',
    link: '/products/paperless-board-meeting/',
    description: 'It streamlines your organization’s board meeting processes by providing directors easy and secure access to their board papers — anywhere, anytime, while giving administrators an efficient solution to prepare and manage board meetings.'
  },
  {id:5, name:'Files sharing and collaboration', imgName: 'fsc.avif',
    link: '/products/file-cloud/',
    description: 'Secure and efficient file sharing with real-time collaboration tools that enable teams to edit, organize, and manage documents seamlessly from anywhere. Boost productivity, maintain version control, and ensure data privacy—all in one platform.'
  },
  {id:6, name:'Environmental Monitor', imgName: 'sr.avif',
    // link: '/products/environmental-monitor',
    link: '/products/environment-monitoring-system/',
    description: 'Nowadays, a “Data Center” is a critical part of a business infrastructure. Improper environment conditions can permanently damage the system which can cause irretrievable data and lost business to the Organization.'
  },
  // {id:7, name:'IT Network Monitoring & Reporting Appliance', imgName: 'itnm.avif',
  //   link: '/products/it-networking-reporting-appliance/',
  //   description: 'Our appliance-based architecture simplifies deployment, with all hardware and software pre-integrated. Appliance options support any environment size or redundancy needs, including clustering, hot-standby, and centralized management.'
  // },
  {id:8, name:'WEEDS BlackBox Suite', imgName: 'weeds.avif',
    link: '/products/weeds-black-box-suite/',
    description: 'WEEDS BlackBox Suite is a system that can identify and respond to information usage and system organization behaviors occurring within a company at an early stage.\n' +
      'It is a next-generation security system that provides everything from surveillance to risk management on a single service platform.'
  },
  {id:9, name:'AnyDb', imgName: 'anydb.avif',
    link: '/products/anydb/',
    description: 'No more scattered spreadsheets or rigid tools. Organize and run your business with connected data and customizable workflows.Suitable for any business from solopreenurs, professionals to small and medium and large enterprises.'
  },
]

const testimonialList = [
  // [
    {
      img: "dhl.avif",
      name: "Praveen Sashi ",
      position: "Head of IT at DHL EXPRESS.",
      content:
        "MESOFT Business Solutions is a professional company who deliver value for money at a high professional standard while maintaining a friendly working relationship with their customers. They understand the market and it’s requirements as well as help create better solutions for our IT projects. They have a good team of enthusiastic programmers who don't hesitate to put forward their suggestions for product improvement. A true partner that we value working with. Keep up the Good Work.",
      translateKeys: {
          content: "testimonial_1"
      }
    },
    {
      img: 'sh.avif',
      name: "Sheikh Zayed Housing",
      position: "Head of Networks & Technical Support, IT Department",
      content:
        "My feedback about MESOFT Business Solutions LLC & services: Good service, Best price, Quick response to the problems, Good corporate & flexibility",
      translateKeys: {
        content: "testimonial_2"
      }
    },
    {
      img: 'apl.avif',
      name: "Uma Saseendran , APL Middle East Africa Region",
      position: "Regional IT Manager",
      content:
        "We are glad that we chose your services and your support proves that we have chosen the best and the right. Approaching issues from customer’s perspective is an excellent trait of your team. Your team uses their expertise to take deeper view into the issues and resolve it quickly by giving competitive solutions. We are happy with your excellent team and commend your response and eagerness to assist us.",
      translateKeys: {
        content: "testimonial_3"
      }
    },
  // ],
  // [
    {
      img: 'https://placehold.co/800x800/avif',
      name: "Sultan Alghazal",
      position: "Electronic Service Section  Sharjah Naturalisation and Residency Department",
      content:
        "We would like to thank you on well done job that has been achieved on upgrading our data center in very short time and with quality service.",
      translateKeys: {
        content: "testimonial_4"
      }
    }
  // ],
];

const mainBrand = [
  {id: 1, imgName: 'acer.png'},
  {id: 2, imgName: 'dhl.png'},
  {id: 3, imgName: 'en.png'},
  {id: 4, imgName: 'rta.png'},
  {id: 5, imgName: 'cat.png'},
  {id: 6, imgName: 'alhilal.png'}
]

const aboutText = [
  {
    id: 1,
    title: 'We Are Customer Driven',
    titleTranslateKey: 'weAreCustomerDriven',
    description: 'As an organization MESOFT is dedicated to the principle of customer service. With the benefit of local understanding and insight, we provide software and other services that are relevant, practical and useful for the demands of business. We continually seek to leverage our individual and collective capabilities and synergism to the benefit of our customers.',
    descriptionTranslateKey: 'asAnOrganizationMesoft'
  },
  {
    id: 2,
    title: 'We Are Dedicated',
    titleTranslateKey: 'weAreDedicated',
    description: 'We are constantly challenged and encouraged by our customers to deliver the best and we have stood by them. We view each challenge as a growth opportunity. Our software developers have in-depth knowledge of various technologies enabling us to develop various kinds of software solutions and services depending upon the client requirements.',
    descriptionTranslateKey: 'weAreDedicatedDescription'
  },
  {
    id: 3,
    title: 'We Believe In Quality',
    titleTranslateKey: 'weBelieveInQuality',
    description: 'We are committed to deliver a wide spectrum of comprehensive services using the state-of-the art technologies with cost effective and quality software solutions that would make a difference to your business.',
    descriptionTranslateKey: 'weAreCommittedToDeliver'
  },
]

const downloadSvg = (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className="w-5 h-5"
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
      strokeWidth={2}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M4 16v2a2 2 0 002 2h12a2 2 0 002-2v-2M7 10l5 5m0 0l5-5m-5 5V4"
      />
    </svg>);

const verifySvg = require('../assets/images/verify.png');

const iVisitaCircles = [
  {
    items: [
      {
        iconName: 'driver-license.png',
        title: 'EMIRATES ID',
        titleTranslateKey: 'eid',
        desc: 'Seamlessly sign-in and capture visitor information using emirates ID',
        descTranslateKey: 'eidDesc',
        bgColor: 'bg-red-500'
      },
    ],
    cols: 'grid-cols-1'
  },
  {
    items: [
      { iconName: 'check-in-calendar.png',
        title: 'SMART CHECK-IN',
        titleTranslateKey: 'smartCheckIn',
        desc: 'Maximize your front desk’s efficiency by allowing the receptionists to work on other important projects while your visitors sign themselves in.',
        descTranslateKey: 'smartCheckInDesc',
        bgColor: 'bg-violet-500'
      },
      { iconName: 'user-check.png',
        title: 'PRE-REGISTER VISITOR',
        titleTranslateKey: 'preRegisterVisitor',
        desc: 'Pre-register visitors before they arrive. Select a host and schedule a visit with information like date, time and location.',
        descTranslateKey: 'preRegisterVisitorDesc',
        bgColor: 'bg-green-500' }
    ],
    cols: 'grid-cols-1 md:grid-cols-2'
  },
  {
    items: [
      { iconName: 'shield-trust.png',
        title: 'VISITOR BADGES',
        titleTranslateKey: 'visitorBadges',
        desc: 'Print visitor badges automatically as visitors sign-in. Showcase your brand on the visitor badges as well.',
        descTranslateKey: 'visitorBadgesDesc',
        bgColor: 'bg-yellow-500'
      },
      { iconName: 'chart-pie.png',
        title: 'SYSTEM REPORTS',
        titleTranslateKey: 'systemReports',
        desc: 'You can access your visitor lists, and create reports through our web backend interface.',
        descTranslateKey: 'systemReportsDesc',
        bgColor: 'bg-cyan-500'
      },
      { iconName: 'bell-notification.png',
        title: 'INSTANT NOTIFICATIONS',
        titleTranslateKey: 'instantNotifications',
        desc: 'Receive visitor arrival notifications using email or SMS. This saves your receptionist a ton of time as they don’t need to call or email the host anymore.',
        descTranslateKey: 'instantNotificationsDesc',
        bgColor: 'bg-slate-500' }
    ],
    cols: 'grid-cols-1 md:grid-cols-3'
  }
]

const webApplicationCardInfo = [
  {
    id: 1,
    title: 'Quality Assurance Testing',
    description: 'An important part of development is testing every possible interaction with the application. Mesofts skilled QA team thoroughly tests all features before they are deployed to the public. Mesoft isnt satisfied until the highest level of quality is attained.',
    translationKey: {
      title: 'cardInfo.qa_title',
      description: 'cardInfo.qa_desc'
    }
  },
  {
    id: 2,
    title: 'Performance, Load and Stress Testing',
    description: 'Performance testing is a part of Mesofts development process. Mesoft builds sites for success and develops to allow for scalability and future growth. Advanced applications require greater server resources — Mesoft builds automated test cases to simulate thousands or millions of users, to ensure that your site can handle the traffic.',
    translationKey: {
      title: 'cardInfo.performance_title',
      description: 'cardInfo.performance_desc'
    }
  },
  {
    id: 3,
    title: 'Usability',
    description: 'Usability is critical to the success of a web site. Although Mesoft builds applications that can perform any complex task, simple, user-friendly interface designs are also integrated. Your target audience will appreciate the difference they discover, resulting in repeat usage and a great brand experience.',
    translationKey: {
      title: 'cardInfo.usability_title',
      description: 'cardInfo.usability_desc'
    }
  },
  {
    id: 4,
    title: 'Security',
    description: 'Mesoft is experienced with the integration of standard and high-level security compliance standards and procedures, and routinely implement PCI (Payment Card Industry) Compliance and HIPPA Compliance requirements.',
    translationKey: {
      title: 'cardInfo.security_title',
      description: 'cardInfo.security_desc'
    }
  },
]

const cFlowCardInfo = [
  {
    id: 1,
    title: 'financeAccounting',
    description: [
      "checkPaymentRequests",
      "vendorAdditions",
      "clientInvoicing",
      "capexApprovals"
    ]
  },
  {
    id: 2,
    title: "itOperations",
    description: [
      "taskAssignment",
      "supportProcess",
      "workOrderCompletion"
    ]
  },
  {
    id: 3,
    title: "procurement",
    description: [
      "quotationManagement",
      "purchaseRequest",
      "purchaseReceipt"
    ]
  },
  {
    id: 4,
    title: "hrAdmin",
    description: [
      "employeeOnboarding",
      "leaveApplication",
      "recruitmentProcess",
      "employeeExit",
      "employeeDataChange",
      "weeklyTimesheet",
      "teamActivityPlanner",
      "travelRequest",
      "expenseReimbursement"
    ]
  },
  {
    id: 5,
    title: 'salesMarketing',
    description: [
      "newsletterApproval",
      "marketingCollateralReview",
      "pressReleaseApproval",
      "blogContentReview",
      "businessEnquiry",
      "salesDiscountApproval",
      "salesIncentiveClaim",
      "orderTracking",
      "productCatalogueUpdate"
    ]
  }
];

const cFlowSecondaryCard = [
  {
    id: 1,
    title: "wysiwygTitle",
    description: [
      "wysiwygDescription",
    ]
  },
  {
    id: 2,
    title: "integrationTitle",
    description: [
      "integrationDescription",
    ]
  },
  {
    id: 3,
    title: "multiDeviceTitle",
    description: [
      "multiDeviceDescription",
    ]
  },
  {
    id: 4,
    title: "dataPriorityTitle",
    description: [
      'dataPriorityDescription',
    ]
  }
]

const faqs = [
  {
    translateKeys: {
      question: "faq.needTechnicalSkillsQuestion",
      answer: "faq.needTechnicalSkillsAnswer"
    },
    question: "Do I need technical skills to use AnyDB?",
    answer:
      "No. If you know how to use a spreadsheet, you can use AnyDB. It’s built to be intuitive while offering powerful automation, collaboration, and structured data management without coding."
  },
  {
    translateKeys: {
      question: "faq.isERPQuestion",
      answer: "faq.isERPAnswer"
    },
    question: "Is AnyDB an ERP?",
    answer:
      "Not exactly. Traditional ERPs are rigid, complex, and expensive. AnyDB is an adaptive data platform that gives growing businesses ERP-like capabilities without the bloated features, high costs, or vendor lock-in."
  },
  {
    translateKeys: {
      question: "faq.dataMigrationQuestion",
      answer: "faq.dataMigrationAnswer"
    },
    question: "Can I migrate my data from Excel, Google Sheets, or other tools?",
    answer:
      "Yes. You can easily import your data from spreadsheets, databases, and business tools. AnyDB helps consolidate scattered data so you no longer have to switch between apps to find critical business info."
  },
  {
    translateKeys: {
      question: "faq.comparisonQuestion",
      answer: "faq.comparisonAnswer"
    },
    question: "How does AnyDB compare to tools like Airtable, Smartsheet, or Notion?",
    answer:
      "Unlike these tools, AnyDB offers true flexibility in structuring data, cross-referencing multiple departments, and scaling with your business without hidden costs. It’s built for team-wide collaboration, not just project tracking."
  },
  {
    translateKeys: {
      question: "faq.automationQuestion",
      answer: "faq.automationAnswer"
    },
    question: "What kind of automations does AnyDB support?",
    answer:
      "You can create custom workflows, trigger actions, and automate repetitive tasks—all without coding. Manage approvals, data updates, and cross-team collaboration seamlessly."
  },
  {
    translateKeys: {
      question: "faq.scalabilityQuestion",
      answer: "faq.scalabilityAnswer"
    },
    question: "What makes AnyDB more scalable than other solutions?",
    answer:
      "Unlike most database tools that become restrictive as teams grow, AnyDB lets you expand, customize, and manage access granularly without hitting unexpected pricing jumps or data limitations."
  }
];

const classicSlider = [
  {
    id: 1,
    title: 'Let’s Build Your Dream Project Together With Us',
    img: img1,
    translateKey: {
      title: "letsBuild",
      description: "weCombineInnovation",
    },
    description: 'We combine innovation, strategy, and craftsmanship to build solutions tailored to your goals. Let’s turn your dream project into a reality together.'
  },
  {
    id: 2,
    title: 'Transform Your Ideas Into Reality With Our Expert',
    img: img2,
    translateKey: {
      title: "transformIdeas",
      description: "everyGreatIdea",
    },
    description: "Every great idea deserves expert execution. Our team of professionals is dedicated to turning your concepts into reality through strategic thinking, creative solutions, and technical excellence."
  },
  {
    id: 3,
    title: 'We Create Customized Software Base On Your Business Requirement Needs',
    img: img3,
    translateKey: {
      title: "weCreateCustomizedSoftware",
      description: "CustomizedSoftwareDevelopment",
    },
    description: "Customized software development refers to the process of designing, creating, deploying, and maintaining software specifically to meet the unique needs and workflows of a business or individual.",
  },
  {
    id: 4,
    title: 'A Complete Visitor Management System Smart, simple, and secure way to register and track visitors.',
    img: img4,
    translateKey: {
      title: "sliderIVIsita",
      description: "sliderIVIsitaDescription",
    },
    description: 'Visitor management solution built to simplify check-ins, strengthen security, and optimize visitor tracking. Whether it\'s a first-time guest or a returning client, every visit is managed with ease, efficiency, and confidence.'
  }
];

export {
  aboutCards,
  aboutVision,
  serviceData,
  portfolioData,
  navList,
  clientSlider,
  productSlider,
  menuDb,
  testimonialList,
  mainBrand,
  aboutText,
  downloadSvg,
  verifySvg,
  iVisitaCircles,
  webApplicationCardInfo,
  cFlowCardInfo,
  cFlowSecondaryCard,
  faqs,
  classicSlider
}
